import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./c9PDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper";
import { drawSummary } from "./drawSummary";

export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a4",
  });

  const { grouped, total } = groupByShop(rows);

  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(
        doc,
        shop,
        grouped[shop].rows,
        grouped[shop].total
      );
    });

  // Pass calculated overall total to summary
  drawSummary(doc, summary, total, rows);

  drawFooter(doc, month, year, title);

  handlePdf(doc, PDF_ACTION.VIEW);
}

function groupByShop(rows) {
  const groups = {};

  // Overall total
  const total = {
    TotalLabour: 0,
    TotalStore: 0,
    Freight: 0,
    Proforma: 0,
    GrandTotal: 0,
    FreightRate: Number(rows[0]["StoreFreight"] || 0),
    ProformaRate: Number(rows[0]["proformaoncost"] || 0),

  };

  rows.forEach((row) => {
    const shop = row.userid ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          TotalLabour: 0,
          TotalStore: 0,
          Freight: 0,
          Proforma: 0,
          GrandTotal: 0,
          FreightRate: 0,
          ProformaRate: 0,
        },
      };
    }

    // Add row
    groups[shop].rows.push(row);

    // ================= LABOUR =================
    const totalLabour =
      Number(row["DIRECT LABOUR"] || 0) +
      Number(row["ON COST LABOUR"] || 0);

    // ================= STORE =================
    const totalStore =
      Number(row["DIRECT STORE"] || 0) +
      Number(row["ON COST STORE"] || 0);

    // ================= FREIGHT =================
    const freight =
      totalStore *
      (Number(row["StoreFreight"] || 0) / 100);

    // ================= PROFORMA =================
    const proforma =
      totalLabour *
      (Number(row["proformaoncost"] || 0) / 100);


   

    // ================= GRAND TOTAL =================
    const grandTotal =
      totalLabour +
      totalStore +
      freight +
      proforma;

    // ================= SHOP TOTAL =================
    groups[shop].total.TotalLabour += totalLabour;
    groups[shop].total.TotalStore += totalStore;
    groups[shop].total.Freight += freight;
    groups[shop].total.Proforma += proforma;
    groups[shop].total.GrandTotal += grandTotal;

    // ================= OVERALL TOTAL =================
    total.TotalLabour += totalLabour;
    total.TotalStore += totalStore;
    total.Freight += freight;
    total.Proforma += proforma;
    total.GrandTotal += grandTotal;
  });

  return {
    grouped: groups,
    total,
  };
}

